import { isProduction } from '#app/utils/is-production'

export const SendViewContentMetaPixelEvent = (eventData: any) => {
	const metaEventData = {
		content_category: eventData.content_category || undefined,
		content_ids: eventData.content_ids || undefined,
		content_name: eventData.content_name || 'Page View',
		content_type: eventData.content_type || undefined,
		currency: eventData.currency || undefined,
		value: eventData.value || undefined,
	}

	const filteredEventData = Object.fromEntries(
		Object.entries(metaEventData).filter(([_, v]) => v !== undefined),
	)

	const options = {
		dataProcessingOptions: ['dpo'],
		eventID: eventData.eventID || `sh-${new Date().getTime()}-${Math.random()}`,
	}

	if (typeof window.fbq === 'function' && isProduction()) {
		window.fbq('track', 'ViewContent', filteredEventData, options)
	}
}
